import React, { useState, useEffect, useContext, useCallback } from "react";
import { isEmpty, callApi, getPayrollStatus } from "bodycodi/cmap/app/js/common";

import CustomDialog from "bodycodi/cmap/app/components/common/customDialog";
import { DispatchContext, StateContext } from "bodycodi/cmap/app/components/common/context";
import PopupHeader from "bodycodi/cmap/app/components/common/popupHeader";

import background from "bodycodi/cmap/app/img/my-page-background.png";
import icon_right_gray_18 from "bodycodi/cmap/app/svg/icon_right_gray_18.svg";
import googleLogin from "bodycodi/cmap/app/img/google-login.png";
import MainCenterLogo from "bodycodi/cmap/app/img/icon-main-flag.png";
import Toggle from "./toggle";
import AccountMngtPop from "./accountMngtPop";
import ChangePassword from "./changePasswordPop";
import Img from "./img";

import { useSelector } from "react-redux";
import { RootState } from "bodycodi/cmap/app/redux/store";
import TermsAndPolicy from "./termsAndPolicy";
import SalaryStatementPop from "./salary";
import CenterMngtIndexPop from "./centerMngtIndexPop";

const GCLD_REDIRECT_URI = process.env.REACT_APP_GCLD_REDIRECT_URI;

const MyPagePopWrap = () => {
  const { state } = useContext(StateContext);
  const { dispatch } = useContext(DispatchContext);

  const handleClose = () => {
    dispatch({ type: "POP_UP_OPEN", id: "MY_PAGE_POP", open: { myPagePop: false } });
  };

  return (
    <CustomDialog open={state.myPagePop} onClose={handleClose}>
      <PopupHeader title="마이페이지" onClickBack={handleClose} />
      {state.myPagePop && <MyPagePop />}
    </CustomDialog>
  );
};

type vo = {
  MobileMembersVO: any;
  CoachVO: any;
  seqPlusSeller: number | null;
};

const MyPagePop = () => {
  const { seqPartner, seqPartnerBranch } = useSelector((state: RootState) => state.partner);
  const { dispatch } = useContext(DispatchContext);
  const [myPageData, setMyPageData] = useState({
    MobileMembersVO: {},
    CoachVO: {},
    seqPlusSeller: null,
  });
  const [refresh, setRefresh] = useState(1);
  const { MobileMembersVO, CoachVO, seqPlusSeller }: vo = myPageData;

  useEffect(() => {
    callApi("/cmap5010/viewMyPage", {}, "GET").then((res) => {
      if (isEmpty(res.CoachVO)) {
        res.CoachVO = null;
      }
      setMyPageData({ ...myPageData, ...res });
    });
  }, [refresh, seqPartner, seqPartnerBranch]);

  const togglePushAlarm = async (isCheckAlarm: boolean) => {
    callApi("/alarm", { flag: isCheckAlarm ? "ON" : "OFF" }, "PATCH").then(() => {
      setMyPageData((previousValue) => ({
        ...previousValue,
        MobileMembersVO: {
          ...previousValue.MobileMembersVO,
          isPushAlarm: isCheckAlarm ? 1 : 0,
        },
      }));
    });
  };

  const handleSyncGoogleCalendar = () => {
    callApi("/calendars/client-secrets", {}, "GET").then((res) => {
      const googleUrl = `${res.authUri}?client_id=${res.clientId}&redirect_uri=${GCLD_REDIRECT_URI}/gcldSucces&scope=https://www.googleapis.com/auth/calendar&response_type=code&access_type=offline&include_granted_scopes=true&prompt=consent&state=${MobileMembersVO.seqMobileMembers}`;
      if (window.ReactNativeWebView) {
        const data = JSON.stringify({
          type: "openExternalLink",
          link: googleUrl,
        });
        window.ReactNativeWebView.postMessage(data);
      } else {
        window.location.href = googleUrl;
      }
      dispatch({ type: "POP_UP_OPEN", id: "MY_PAGE_POP", open: { myPagePop: false } });
      dispatch({
        type: "ALERT_SETTING",
        data: {
          alert: false,
        },
      });
    });
  };

  const handleRemoveGoogleCalendar = () => {
    callApi("/calendars/stop-sync", {}, "PATCH").then((res) => {
      if (res.MsgVO?.msgCd === "G00001") {
        dispatch({ type: "UPDATE", data: { toast: true, toastText: res.MsgVO.msgCtnt } });
      } else {
        setMyPageData((previousValue) => ({
          ...previousValue,
          MobileMembersVO: {
            ...previousValue.MobileMembersVO,
            syncYn: "OFF",
          },
        }));
      }
    });
  };

  const handleClickGcld = (isToggle: boolean) => {
    if (isToggle) {
      dispatch({
        type: "ALERT_SETTING",
        data: {
          header: "스케줄 자동 내보내기",
          body: (
            <div>
              바디코디의 스케줄을 구글 캘린더에
              <br />
              자동으로 내보내기 할 수 있어요.
              <br />
              바로 연동하려면 로그인 해주세요!
              <br />
              <br />
              <img src={googleLogin} onClick={handleSyncGoogleCalendar} />
            </div>
          ),
          cancelAlert: () => ({}),
          closeAlert: () => ({}),
          alert: true,
          cancleYn: "C",
          redYn: false,
        },
      });
    } else {
      dispatch({
        type: "ALERT_SETTING",
        data: {
          header: "구글 캘린더 연동 해지",
          body: "구글 캘린더 연동을 해지할까요?",
          cancelAlert: () => ({}),
          closeAlert: handleRemoveGoogleCalendar,
          alert: true,
          cancleYn: true,
          redYn: false,
        },
      });
    }
  };

  const update = useCallback(() => {
    setRefresh(refresh + 1);
  }, [refresh]);

  const openCenterMngtPop = () => {
    dispatch({
      type: "POP_UP_OPEN",
      id: "CENTER_MNGT_INDEX_POP",
      open: { centerMngtIndexPop: true },
    });
  };

  const clickAccount = () => {
    dispatch({ type: "POP_UP_OPEN", id: "ACCOUNT_MNGT_POP", open: { accountMngtPop: true } });
  };

  const openSalaryStatement = () => {
    dispatch({
      type: "POP_UP_OPEN",
      id: "SALARY_STATEMENT_POP",
      open: { salaryStatementPop: true },
    });
  };

  const openTermsAndPolicy = () => {
    dispatch({
      type: "POP_UP_OPEN",
      id: "TERMS_AND_POLICY_POP",
      open: { termsAndPolicyPop: true },
    });
  };

  return (
    <>
      <div className="popup-body my-page-pop">
        <div className="my-page-background">
          <img src={background} />
        </div>
        <div className="my-page-info">
          <Img className="profile-img" src={CoachVO?.coachImgUrl} />
          <div className="profile-name">{MobileMembersVO.name} 강사</div>
          <div className="profile-email">{MobileMembersVO.email}</div>
          <div className="profile-main-center">
            <img src={MainCenterLogo} />
            <span className="center-name">{CoachVO.partnerName}</span>
          </div>
          <div className="check-salary" onClick={openSalaryStatement}>
            <div className="title">
              급여 내역서
              {(CoachVO?.settlementStatus === "PAYROLL_REQUEST" ||
                CoachVO?.settlementStatus === "PAYROLL_RE_REQUEST") && (
                <span className="red-badge" />
              )}
            </div>

            <div>
              {getPayrollStatus(CoachVO?.settlementStatus)}
              <img src={icon_right_gray_18} />
            </div>
          </div>
          {(CoachVO?.settlementStatus === "PAYROLL_REQUEST" ||
            CoachVO?.settlementStatus === "PAYROLL_RE_REQUEST") && (
            <span className="tip-bubble">급여 내역서를 확인 후 동의해 주세요!</span>
          )}
        </div>
        <div className={"my-page-center-list" + (isEmpty(CoachVO) ? " disable" : "")}>
          <div className="my-page-center-btn" onClick={openCenterMngtPop}>
            <span className="title">센터 관리</span>
            <img src={icon_right_gray_18} />
          </div>

          <div className="my-page-center-btn no-padding" onClick={clickAccount}>
            <span className="title">내 계정 관리</span>
            <img src={icon_right_gray_18} />
          </div>
        </div>
        <div className="my-page-setting">
          <div className="my-page-title">설정</div>
          <div className="my-page-toggle-wrap">
            <div className="title">푸쉬알림</div>
            <Toggle
              isChecked={MobileMembersVO.isPushAlarm ? true : false}
              onChange={togglePushAlarm}
            />
          </div>
          <div className="my-page-toggle-wrap">
            <div className="title">스케줄을 캘린더에 자동 내보내기</div>
            <Toggle
              isChecked={MobileMembersVO.syncYn === "ON" ? true : false}
              onChange={handleClickGcld}
            />
          </div>
        </div>
        <div className="my-page-terms">
          <div className="my-page-center-btn" onClick={openTermsAndPolicy}>
            <span className="title">약관 및 정책</span>
            <img src={icon_right_gray_18} />
          </div>
          <div className="my-page-center-btn">
            <span className="title">앱 버전</span>
            <span className="gray">1.1.5</span>
          </div>
        </div>
      </div>

      <SalaryStatementPop updateMyPage={update} />
      <CenterMngtIndexPop CoachVO={CoachVO} update={update} />
      <AccountMngtPop updateP={update} />
      <ChangePassword />
      <TermsAndPolicy />
    </>
  );
};

export default MyPagePopWrap;
